export const jayCarFormStyles = {
  base: {
    color: '#212121',
    fontSize: '14px',
    lineHeight: '16px',
    fontFamily: 'Figtree, sans-serif',
  },
  error: {
    color: '#e20f14',
  },
  placeholder: {
    color: '#757575',
  },
  validated: {
    color: '#95c11f',
  },
}

export const rtmFormStyles = {
  base: {
    color: '#000000',
    fontSize: '14px',
    lineHeight: '16px',
    fontFamily: 'Roboto, sans-serif',
  },
  error: {
    color: '#e20f14',
  },
  placeholder: {
    color: '#757575',
  },
  validated: {
    color: '#78b032',
  },
}
